/* istanbul ignore file  */

export enum DashboardAccessStatus {
    NotFound = 0,
    Authorized = 1,
    Unauthorized = 2
}
